import { toMajorUnits } from 'helpers/currency-symbol';

import { ITEM_AVAILABILITY_STATUS, PARTNER_STATE } from './SkuItems.constants';

/**
 * API <-> UI naming convention:
 *   group    -> menu       (getMenu*)
 *   subgroup -> category   (getCategory*)
 *   item     -> item       (getItem*)
 */
export const toComparableId = id => (id === undefined || id === null ? null : String(id));

export const getMenuId = menu => toComparableId(menu?.id);
export const getMenuName = menu => menu?.name || '';
export const getPublished = entity => entity?.published;
export const isEnabledMenu = menu => menu?.enabled === true && menu?.disabled !== true;
export const isVisibleSkuEntity = entity => Boolean(entity) && entity.partnerState !== PARTNER_STATE.DELETED;

export const getCategoryId = category => toComparableId(category?.id);
export const getCategoryMenuId = category => toComparableId(category?.groupId);
export const getCategoryName = category => category?.name || '';

export const getItemId = item => toComparableId(item?.id);
export const getItemName = item => item?.name || '';
export const getItemPayoutRate = item => {
  const payout = item?.payoutPrice?.currencyUnits;
  const currencyCode = item?.payoutPrice?.currencyCode;
  if (payout === null || payout === undefined || payout === '') {
    return null;
  }

  const numericPayout = typeof payout === 'string' ? Number(payout.replace(/[^0-9.-]/g, '')) : Number(payout);
  if (Number.isNaN(numericPayout)) return null;
  if (!currencyCode) return null;
  return toMajorUnits(currencyCode, numericPayout);
};

export const getItemAvailabilityStatus = item => {
  if (!item) return null;
  if (item.published !== true) return null;
  if (item.partnerState === PARTNER_STATE.UNAVAILABLE) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY;
  if (item.soldOut === true) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_TODAY;
  if (item.enabled === false) return ITEM_AVAILABILITY_STATUS.UNAVAILABLE_INDEFINITELY;
  return ITEM_AVAILABILITY_STATUS.AVAILABLE;
};
export const getItemCategoryIds = item => {
  const directCategoryId = item?.subGroupId;
  const categoryIds = item?.subGroupIds;

  if (Array.isArray(categoryIds) && categoryIds.length > 0) {
    return categoryIds.map(toComparableId).filter(Boolean);
  }

  if (directCategoryId !== null && directCategoryId !== undefined) {
    return [toComparableId(directCategoryId)];
  }

  return [];
};

export const getSubgroupId = subgroup => toComparableId(subgroup?.id);

const UNCATEGORIZED_ID_PATTERN = /^UNCATEGORIZED_\d+$/;
export const isUncategorizedCategoryId = id => UNCATEGORIZED_ID_PATTERN.test(id);
export const isUncategorizedCategory = category => isUncategorizedCategoryId(getCategoryId(category));
